import React from 'react'
import { Menu } from 'react-native-paper'
import { useRecoilState } from 'recoil'
import { Unidade } from '@/domain/models'
import { Box, Button } from '@/presentation/components'
import { useTheme, useThemeClient } from '@/presentation/hooks'
import { isOpenMenuUnitsState } from './atom'

type UnitsSelectorProps = {
  disabled: boolean
  currentUnit: number
  setCurrent: (currentUnit: number) => void
  units: Unidade[]
}

export const UnitsSelector: React.FC<UnitsSelectorProps> = ({
  disabled,
  setCurrent,
  units,
  currentUnit
}) => {
  const theme = useTheme()
  const { getThemeClient } = useThemeClient()
  const [isMenuOpen, setMenuOpen] = useRecoilState(isOpenMenuUnitsState)

  const themeClient = getThemeClient()

  const handleSelectUnit = (currentUnit: number): void => {
    setCurrent(currentUnit)
    setMenuOpen(false)
  }

  return (
    <Box>
      <Menu
        visible={isMenuOpen}
        onDismiss={() => setMenuOpen(false)}
        anchorPosition='bottom'
        anchor={
          <Button
            disabled={disabled}
            color={themeClient.buttonSave}
            style={{ margin: 12, borderRadius: 15 }}
            tintColor={theme.colors.white}
            onPress={() => setMenuOpen(true)}
            loading={disabled}
            loadingIndicatorPosition='overlay'
            title={currentUnit.toString().padStart(4, '0')}
          />
        }
      >
        {units?.map((config) => (
          <Menu.Item
            key={config.codigoUnidade}
            disabled={config.codigoUnidade === currentUnit}
            onPress={() => handleSelectUnit(config.codigoUnidade)}
            title={`${config.codigoUnidade.toString().padStart(4, '0')} - ${config.nomeUnidade}`}
          />
        ))}
      </Menu>
    </Box>
  )
}
